// Ladder settings (chat's Settings button): seconds between steps of the ladder
// window's auto ladder (the price move per step is picked in each ladder window,
// LADDER_STEPS). Kept in localStorage, shared by all chats.

import { create } from "zustand";

export const LADDER_STEPS = [0.01, 0.05, 0.1];
export const LADDER_DURATIONS = [0.5, 1, 2];

const KEY = "ibkr_fast_ladder_settings";

type LadderSettings = { stepDuration: number };

function load(): LadderSettings {
  const fallback = { stepDuration: LADDER_DURATIONS[0] };
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? "{}");
    return {
      stepDuration: LADDER_DURATIONS.includes(saved.stepDuration) ? saved.stepDuration : fallback.stepDuration,
    };
  } catch {
    return fallback;
  }
}

export const useLadderSettings = create<LadderSettings & { set: (change: Partial<LadderSettings>) => void }>()((set, get) => ({
  ...load(),
  set: (change) => {
    set(change);
    try {
      localStorage.setItem(KEY, JSON.stringify({ stepDuration: get().stepDuration }));
    } catch {}
  },
}));
